import { render, staticRenderFns } from "./del-exam.vue?vue&type=template&id=096c8c88&scoped=true"
import script from "./del-exam.vue?vue&type=script&lang=ts"
export * from "./del-exam.vue?vue&type=script&lang=ts"
import style0 from "./del-exam.vue?vue&type=style&index=0&id=096c8c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096c8c88",
  null
  
)

export default component.exports